<template>
	<table
		v-if="item.familiares.length > 0"
		class="table table-bordered bg-white table-sm"
	>
		<thead>
			<tr>
				<th>Código</th>
				<th>Nome Completo</th>
				<th>Posição Familiar</th>
				<th>Pendências</th>
				<th>Ações</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="familiar in item.familiares" :key="familiar.id">
				<td>
					<span v-if="familiar.codigo_usuario_cadunico">
						CAD:{{ familiar.codigo_usuario_cadunico }}
					</span>
					<span v-else> ID:{{ familiar.id }} </span>
				</td>
				<td>
					<strong>{{ familiar.nome_completo }}</strong>
					<br />
					NIS: {{ familiar.documento ? familiar.documento.nis : "--" }}<br />
					Sexo:{{ familiar.sexo == "1" ? "Masculino" : (familiar.sexo == "2" ?"Feminino" :'Intersexo')}}
					<br />
					Idade: {{ familiar.idade }} ano(s)
				</td>
				<td>
					<span>
						{{
							verificarValueArray(familiar.posicao_familiar, $root.arrays.posicao_familiar)
						}}
					</span>
				</td>
				<td class="text-center">
					<div style="position: relative; width: 75px" v-if="familiar.count_pendencias">
						<b-spinner
							class="spiner-counter"
							variant="danger"
							type="grow"
							small
						></b-spinner>

						<b-button
							:title="$t('Pendências')"
							@click="abrirModal(familiar.pendencias, familiar.nome_completo)"
							class="px-2 mb-0"
							size="xs"
							type="button"
							v-b-tooltip.hover
							:variant="familiar.count_pendencias ? 'warning' : 'ligth'"
						>
							<b-icon icon="exclamation-triangle-fill"></b-icon>
							<span>
								{{ familiar.count_pendencias }}
							</span>
						</b-button>
					</div>
					<div class="text-secondary" v-else>
						<b-icon icon="exclamation-triangle-fill"></b-icon>
					</div>
				</td>
				<td class="text-center">
					<b-button
						:title="$t('Acessar Prontuário do Usuário')"
						:to="'/dashboard/usuario/edit/' + familiar.id"
						class="px-2 mb-0"
						size="xs"
						type="button"
						v-b-tooltip.hover
						variant="primary"
						target="_blank"
					>
						<i class="fas fa-external-link-square-alt"></i>
					</b-button>
				</td>
			</tr>
		</tbody>
	</table>
</template>
<script>
export default {
	props: ["item"],
	components: {},
	data() {
		return {};
	},
	methods: {
		verificarValueArray(value, array, valueIsArray = false) {
			if (valueIsArray && value) {
				var a = "";
				for (var i = 0; i < value.length; i++) {
					const result = array.filter((item) => item.id == value[i]);
					a += result[0].value + (i < value.length - 1 ? "," : "");
				}

				return a;
			} else {
				const result = array.filter((item) => item.id == value);
				return result[0] ? result[0].value : "";
			}
		},
	},
};
</script>

<style>
.spiner-counter {
	position: absolute;
	top: 0;
	right: 10px;
	margin-top: -0.7rem;
	width: 1.2rem;
	height: 1.2rem;
}
</style>
